import { render } from "./SkipNavigation.vue?vue&type=template&id=6e5f711e&scoped=true&ts=true"
import script from "./SkipNavigation.vue?vue&type=script&lang=ts"
export * from "./SkipNavigation.vue?vue&type=script&lang=ts"

import "./SkipNavigation.vue?vue&type=style&index=0&id=6e5f711e&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5f711e"]])

export default __exports__